export const GET_DETAILS = 'details::GET_DETAILS';
export const GET_DETAILS_SUCCESS = 'details::GET_DETAILS_SUCCESS';
export const GET_DETAILS_FAILURE = 'details::GET_DETAILS_FAILURE';
export const SET_DESCRIPTION_LOADED = 'details::SET_DESCRIPTION_LOADED';
export const SET_UNLOCKED_PAGE = 'details::SET_UNLOCKED_PAGE';

export const SET_DETAILS_EPISODE = 'details::SET_DETAILS_EPISODE';
export const SET_DETAILS_EPISODE_CAST_AND_CREW =
    'details::SET_DETAILS_EPISODE_CAST_AND_CREW';
